import {
  getExchangeRate,
  type BankStatementUploadConfig,
  type CashierUserData,
  type CurrencyPrimitive,
} from "@/api/cashier";
import { decimalMinorUnits, moneyToDecimal } from "@/utils/helpers";
import type Decimal from "decimal.js";

export const isBankStatementMandatory = async (
  config: BankStatementUploadConfig | undefined,
  userData: CashierUserData | undefined,
  paymentMethodId: string | undefined,
  amount: Decimal | undefined,
  amountCurrency: CurrencyPrimitive | undefined
): Promise<boolean> => {
  if (!config) return false;

  if (
    userData?.license_id &&
    config.mandatory_licenses.includes(userData.license_id)
  ) {
    return true;
  }

  if (!amount || !amountCurrency) return false;

  const threshold = moneyToDecimal(config.amount_threshold_aud);
  if (!threshold) return false;

  if (amountCurrency.code === config.amount_threshold_aud.code) {
    return amount.gt(threshold);
  }

  if (!userData || !paymentMethodId) return false;

  const minorAmount = decimalMinorUnits(amount, amountCurrency.decimals);

  const response = await getExchangeRate({
    query: {
      "from-currency-code": amountCurrency.code,
      "to-currency-code": config.amount_threshold_aud.code,
      amount: String(minorAmount),
      "country-code": userData.country_code,
      "license-id": userData.license_id,
      "payment-method-id": paymentMethodId,
      "is-reverse": false,
    },
  });

  if (response.error) return false;

  const converted = moneyToDecimal(response.data.to_money);
  if (!converted) return false;

  return converted.gt(threshold);
};
